<template>
	<div>
		<div xs2 v-if="tablaHeaderTitulo" class="Rectangle-12-Copy-2">
			<span class="DISEAR-ESCALA-PUE">DISEÑAR ESCALA |  PUESTOS VALORADOS</span>
			<div class="Rectangle-5 back" @click="goBackToValuation">
				<span class="Back">Atrás</span>
			</div>
			<div xs2 v-if="tablaHeaderButton__1" class="Rectangle-5" @click="$emit('showChartClick')">
				<span class="Ver-Grfico">Ver Gráfico</span>
			</div>
			<div class="Rectangle-5 orange"  @click="Regresar">
				<span class="Finalizar">Finalizar</span>
			</div>
		</div>
	</div>
</template>

<script>

function Regresar() {
	this.goTo('job-evaluation-processes');
}

function goBackToValuation() {
	this.goTo('job-supply-description-of-charges');
}

export default {
	name: 'app-table-disenar-escala',
	props: {
		tablaHeaderTitulo: {
			default: true,
			type: Boolean,
		},
		tablaHeaderButton__1: {
			default: true,
			type: Boolean,
		},
	},
	methods: {
		Regresar,
		goBackToValuation,
	},
};
</script>

<style lang="scss" scoped>
    .table-title {
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, xlarge);
		margin-left: 22px;
		vertical-align: middle;
	}
	.Rectangle-12-Copy-2 {
		width: 100%;
		max-width: 1032px;
		height: 58px;
		margin: 15px auto 10px;
		padding: 10px 10px 11px 35px;
		border-radius: 9px;
		border: solid 1px #e9e9e9;
		background-color: #fff;
		display: flex;
		align-items: center;
	}
	.DISEAR-ESCALA-PUE {
		width: 478px;
		height: 16px;
		// margin: 11px 396px 15px 0;
		font-family: NeuzeitGroTBold;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		color: #55ac4b;
	}
	.Rectangle-5 {
		width: 143px;
		height: 37px;
		margin: 0 7px 0 246px;
		padding: 6px 4.5px 7px 7px;
		border-radius: 18.5px;
		border: solid 1px #f09c2b;
		text-align: center;
		cursor: pointer;
	}
	.orange {
		margin: 0 0 0 7px;
		padding: 6px 8px 7px 7px;
		background-color: #f09c2b;
	}
	.back {
		width: 100px;
		margin: 0 7px 0 auto;
		padding: 6px 8px 7px 7px;
		border: solid 1px #55ac4b;
	}
	.Back {
		width: 85px;
		height: 24px;
		font-family: NeuzeitGroTBold;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #55ac4b;
	}
	.Ver-Grfico {
		width: 128.5px;
		height: 24px;
		margin: 0 0 0 3px;
		font-family: NeuzeitGroTBold;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #f09c2b;
	}
	.Finalizar {
		width: 128px;
		height: 24px;
		font-family: NeuzeitGroTBold;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/table-disenar-escala/app-table-disenar-escala.vue